import {
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    Chip,
    Box,
    Checkbox,
    ListItemText,
} from "@mui/material"
import React from "react"
import {getOptions} from "../../misc/widget-functions"
const MultiSelectWidget = ({
    widget,
    value = [],
    selectOptions,
    onValueChange,
    disabled,
    triggerAction
}) => {
    const options = selectOptions ? selectOptions : getOptions(widget)
    const onMultiSelectChange = event => {
        const {
            target: {value: selectedValues},
        } = event

        const newValue =
            typeof selectedValues === "string"
                ? selectedValues.split(",")
                : selectedValues
        onValueChange(newValue)
    }

    const handleDelete = chipToDelete => event => {
        event.stopPropagation()
        onValueChange(value.filter(entry => entry !== chipToDelete))
    }

    return (
        <FormControl fullWidth>
            <Select
                id={widget.id}
                key={widget.id}
                multiple
                value={value ?? []}
                onChange={onMultiSelectChange}
                className={widget.className}
                disabled={disabled}
                renderValue={selected => (
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "nowrap",
                            overflowX: "scroll",
                            gap: 0.5,
                        }}
                    >
                        {selected.map(selectedValue => {
                            const selectedOption = options.find(
                                option => option.value === selectedValue,
                            )
                            return (
                                <Chip
                                    key={selectedValue}
                                    label={
                                        selectedOption?.label || selectedValue
                                    }
                                    onDelete={handleDelete(selectedValue)}
                                    onMouseDown={event =>
                                        event.stopPropagation()
                                    }
                                />
                            )
                        })}
                    </Box>
                )}
            >
                {Array.isArray(options) &&
                    options.map(option => (
                        <MenuItem
                            key={option?.id}
                            value={option.value}
                            disabled={option?.disabled}
                        >
                            <Checkbox checked={value?.includes(option.value)} />
                            <ListItemText primary={option?.label} />
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

export default MultiSelectWidget
